<template>
  <div id="r-player"></div>
</template>

<script>
  import {getPlayerStore} from './store';
  import {_Vue} from './index';
  import PlayerComp from './base-player/player';
  import Emitter from '../../mixins/emitter';

  export let _uid = 0;
  function uid() {
    return _uid++;
  }
  export default {
    name: 'ZmPlayer',
    componentName: 'ZmPlayer',
    mixins: [Emitter],
    props: {
      autoPlay: Boolean,
      src: {
        type: String,
        default() {
          return '';
        },
        required: true
      },
      type: {
        type: String,
        default: ''
      },
      vhsWithCredentials: Boolean,
      ccUrl: {
        type: String,
        default: ''
      },

      startTime: {
        type: Number,
        default: 0
      },
      isAudio: Boolean,
      miniPlayer: Boolean,
      poster: {
        type: String,
        default: ''
      },
      speed: {
        type: Number,
        default: 1
      },
      nativeTextTracks: Boolean,
      plugins: {
        type: Object,
        default: () => ({})
      },
      aspectRatio: {
        type: Number,
        default: 0.5625 // default ratio height:width = 9:16
      }
    },
    mounted() {
      const {src, type, vhsWithCredentials, autoPlay, startTime, isAudio, miniPlayer, ccUrl: closeCaptionUrl, speed, poster, plugins, aspectRatio } = this;
      const storeUID = uid();
      const parent = this;
      this.PlayerInstance = new _Vue({
        el: '#r-player',
        store: getPlayerStore(storeUID),
        parent,
        render(h) {
          return h(PlayerComp, {
            props: {
              uid: storeUID,
              options: {
                src,
                type,
                vhsWithCredentials,
                autoPlay,
                startTime,
                isAudio,
                miniPlayer,
                closeCaptionUrl,
                speed,
                poster,
                plugins,
                aspectRatio
              }
            }
          });
        }
      });
    }
  };
</script>

<style>

</style>
